import React from 'react';
import { Link, useParams } from 'react-router-dom';
import BlogByline from '../components/BlogByline.jsx';
import BlogContact from '../components/BlogContact.jsx';
import { FEATURED_CATEGORY_PAGES, findFeaturedWork, getDevBlog } from '../lib/featured.js';

export default function DevBlog() {
  const { category, name } = useParams();
  const decodedName = name ? decodeURIComponent(name) : '';
  const work = findFeaturedWork(category, decodedName);
  const blog = getDevBlog(work);
  const parent = FEATURED_CATEGORY_PAGES[category] || { path: '/', label: 'Overview' };

  if (!work || !blog) {
    return (
      <section className="dev-blog">
        <p className="dev-blog-back">
          <Link to="/blog">← Blog</Link>
        </p>
        <h2>Dev blog not found</h2>
        <p>This featured work does not have a connected markdown blog yet.</p>
      </section>
    );
  }

  return (
    <section className="dev-blog">
      <p className="dev-blog-back">
        <Link to="/blog">← Blog</Link>
        <span aria-hidden="true"> · </span>
        <Link to={parent.path}>{parent.label}</Link>
      </p>
      <header className="dev-blog-header">
        <h2>{blog.title}</h2>
        <BlogByline date={blog.date} author={blog.author} />
      </header>
      <div className="dev-blog-body" dangerouslySetInnerHTML={{ __html: blog.html }} />
      <BlogContact articleTitle={blog.title} />
    </section>
  );
}
